import { apiClient } from "../lib/api";

export const paymentEvidenceApi = {
  listPeriodPayments: (periodId) => apiClient.get(`/payroll/payments/periods/${periodId}`),
  getEmployeePayment: (periodId, employeeId) => apiClient.get(`/payroll/payments/periods/${periodId}/employees/${employeeId}`),
  recordPayment: (periodId, employeeId, formData) => apiClient.post(`/payroll/payments/periods/${periodId}/employees/${employeeId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }),
  confirmPayment: (evidenceId, notes) => apiClient.post(`/payroll/payments/${evidenceId}/confirm`, null, { params: { notes: notes || undefined } }),
  markFailed: (evidenceId, reason) => apiClient.post(`/payroll/payments/${evidenceId}/mark-failed`, null, { params: { reason } }),
  getEvidenceFileUrl: (evidenceId) => `${apiClient.defaults.baseURL}/payroll/payments/${evidenceId}/file`,
  myStatus: () => apiClient.get("/payroll/payments/my/status"),
};
